import React, { FC } from "react";

import { Sort } from "@/components/atoms/Sorting/useSort";
import { Table } from "@/components/molecules";
import { Contract, ContractSortProperty } from "@/shared/domain";

import ContractTableItem from "./ContractTableItem/ContractTableItem";
import { contractTableColumns } from "./utils";

export type ContractTableProps = {
    contracts: Contract[];
    orderBy: Sort<ContractSortProperty>;
    handleSort: (orderBy: ContractSortProperty) => void;
};

const ContractTable: FC<ContractTableProps> = ({ contracts, handleSort, orderBy }) => {
    return (
        <Table<Contract, ContractSortProperty>
            condensed
            columns={contractTableColumns}
            handleSort={handleSort}
            orderBy={orderBy}
            items={contracts}
            renderItem={(contract) => <ContractTableItem contract={contract} key={contract.id} />}
        />
    );
};

export default ContractTable;
